import Model from '../model';

/**
 * Deal Model
 * @property {int} id
 * @property {int} deal_id
 * @property {int|null} document_request_id
 * @property {Array} documents
 * @property {Array} files
 * @property {Date} created_at
 * @property {boolean} is_approved
 * @property {boolean} is_stored
 * @property {string} name
 * @property {string} non_approval_justification
 * @property {boolean} retention_expired
 * @property {Date} retention_expiry_date
 * @property {Object} template_document
 * @property {Boolean} template_document.show_files
 * @property {int} template_document_id
 * @property {boolean} user_deleted
 * @property __className
 */
export default class DocumentModel extends Model {
  /**
   * DocumentModel Constructor
   * @param deal
   */
  constructor(deal) {
    super(deal);
    this.__className = 'DocumentModel';
  }

  /**
   * Helper to get the display name of the document.
   * @returns {string} The display name of the document.
   */
  displayName() {
    if (
      this.template_document
        && this.template_document.show_files
        && this.files.length === 1) {
      const [file] = this.files;
      return `${this.template_document.name} (${file.display_name || file.original_filename})`;
    }
    return this.template_document
      ? this.template_document.name
      : this.name;
  }

  isRequested() {
    return this.document_request_id === null;
  }
}
